import { AuditLogEvent } from '../models/audit-log';
import { toSpacedEventType } from '../pipes/event-type.pipe';

export function normaliseAuditSearch(value: string): string {
  return value.toLowerCase().replace(/[\s_-]+/g, '');
}

export function auditEventMatchesSearch(event: AuditLogEvent, query: string): boolean {
  if (!query || query.trim() === '') {
    return true;
  }

  const tokens = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
  const fields = searchableFields(event);

  return tokens.every(token =>
    fields.some(field => field.includes(token) || normaliseAuditSearch(field).includes(normaliseAuditSearch(token)))
  );
}

function searchableFields(event: AuditLogEvent): string[] {
  return [
    event.author,
    event.eventType,
    toSpacedEventType(event.eventType ?? ''),
    event.timestamp,
    event.participantName,
    JSON.stringify(event.eventDetails ?? '')
  ]
    .filter((value): value is string => !!value)
    .map(value => value.toLowerCase());
}
